module.exports = __webpack_public_path__ + "img/subt.d87d57df.svg";